import React from 'react';
import { motion } from 'framer-motion';
import { GiftIcon } from 'lucide-react';
const bonuses = [{
  num: '1',
  title: 'Der SPS Exam-Vault',
  desc: '10 vollständige Prüfungsmodelle mit detaillierten Lösungen. Eines pro Kernmodul — plus 4 Zusatzprüfungen für Fortgeschrittene. Spart 6 Stunden Prüfungsvorbereitung pro Semester.'
}, {
  num: '2',
  title: 'SPS Übungen & Ladder-Vorlagen',
  desc: '50 Worksheets mit realen Industrieaufgaben. Ladder-Diagramme zum Vervollständigen. Aktiviert technisches Denken und Problemlösung. Kein Vorbereitungsaufwand.'
}, {
  num: '3',
  title: 'Industrielle Schaltpläne & Schemata',
  desc: 'Vollständige Schaltplan-Bibliothek: Pneumatik, Elektropneumatik, SPS-Verdrahtung und Sensoranschlüsse. Professionelles Format DIN A4.'
}, {
  num: '4',
  title: 'Master Admin Pack — Bewertung & Planung',
  desc: 'Bewertungsraster für praktische und theoretische Prüfungen. Semesterplanungsvorlagen nach Industrie 4.0 Lehrplan. Alles für ein ganzes Schuljahr.'
}];
export function BonusSection() {
  return <section className="py-10 px-4" data-id="element-25">
      <div className="max-w-2xl mx-auto" data-id="element-26">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-6" data-id="element-27">
          <h2 className="text-2xl sm:text-3xl font-black text-brand-charcoal mb-3" data-id="element-28">
            Und das ist noch nicht alles.
          </h2>
          <p className="text-base sm:text-lg text-gray-600 font-medium" data-id="element-29">
            Mit Ihrem Kauf erhalten Sie 4 professionelle Toolkits —{' '}
            <span className="text-brand-swiss-red font-bold" data-id="element-30">
              ohne Aufpreis
            </span>
            .
          </p>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4" data-id="element-31">
          {bonuses.map((bonus, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.08
        }} className="bg-white border-2 border-brand-gold/50 rounded-xl p-4 sm:p-5 shadow-sm relative overflow-hidden" data-id="element-32">
              <div className="absolute top-0 left-0 w-full h-1 bg-brand-gold" data-id="element-33" />
              <div className="flex items-center gap-2 mb-2" data-id="element-34">
                <GiftIcon className="w-5 h-5 text-brand-gold shrink-0" data-id="element-35" />
                <h3 className="font-bold text-brand-charcoal text-sm sm:text-base leading-tight" data-id="element-36">
                  BONUS {bonus.num}: {bonus.title}
                </h3>
              </div>
              <p className="text-[13px] sm:text-sm text-gray-600 leading-relaxed" data-id="element-37">
                {bonus.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}